import { Link } from "react-router-dom";
import { PlaneTakeoff } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Not Found" description="Page not found." path="/404" />
      <section className="aoa-container py-32 text-center" data-testid="not-found">
        <div className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-[hsl(var(--aoa-gray-bg))]">
          <PlaneTakeoff className="h-9 w-9 text-[hsl(var(--aoa-royal))]" />
        </div>
        <h1 className="aoa-h1 mt-6 text-[hsl(var(--aoa-navy))]">404 — Off course.</h1>
        <p className="mt-3 text-slate-600">The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link to="/" className="aoa-btn-primary mt-8">Return to Home</Link>
      </section>
    </>
  );
}
